"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var EDITOR_CONFIGURATIONS = {
  format_tags: 'p;h1;h2;h3;h4;h5;h6',
  toolbar: [['Source', '-', 'Format', '-', 'Bold', 'Italic', 'Underline', 'BulletedList', 'NumberedList', 'Link', 'Undo', 'Redo']],
  removeButtons: '',
  removePlugins: 'elementspath,magicline,wysiwygarea',
  extraPlugins: 'divarea',
  resize_dir: 'vertical',
  title: false
};
var _default = EDITOR_CONFIGURATIONS;
exports.default = _default;